'use client';

import { useTranslations } from 'next-intl';
import { Field } from '../../components/field';
import { Input } from '../../components/input';
import { SettingsEditDialog } from '../settings/SettingsEditDialog';
import { useDraftOnOpen } from './useDraftOnOpen';

export type ApplicationNameEditDialogProps = {
  open: boolean;
  name: string;
  loading?: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (name: string) => Promise<boolean>;
};

export function ApplicationNameEditDialog({
  open,
  name,
  loading,
  onOpenChange,
  onSubmit,
}: ApplicationNameEditDialogProps) {
  const t = useTranslations('designSystem.applicationGeneral');
  const tCommon = useTranslations('designSystem.common');
  const [draftName, setDraftName] = useDraftOnOpen({ open, value: name });
  const trimmedName = draftName.trim();

  return (
    <SettingsEditDialog
      open={open}
      title={t('editName')}
      onOpenChange={onOpenChange}
      onSubmit={async () => {
        if (await onSubmit(trimmedName)) {
          onOpenChange(false);
        }
      }}
      loading={loading}
      isSubmitDisabled={!trimmedName || trimmedName === name}
      submitText={tCommon('saveChanges')}
    >
      <Field.Root>
        <Field.Label>{t('name')}</Field.Label>
        <Input
          value={draftName}
          onChange={(event) => setDraftName(event.target.value)}
        />
      </Field.Root>
    </SettingsEditDialog>
  );
}
